import { ListModalCreateView, ListModalCopyView } from "./ListModalCreateView";
import { ListModalLoadedView } from "./ListModalLoadedView";

type ListModalMode = "view" | "edit" | "create";

interface ListModalProps {
    mode: ListModalMode;
    listId?: number;
    sourceId?: number;
    template?: boolean;
    onClose: () => void;
}

export function ListModal({ mode, listId, sourceId, template, onClose }: ListModalProps) {
    if (mode === "create") {
        if (sourceId !== undefined) {
            return <ListModalCopyView key={sourceId} sourceId={sourceId} onClose={onClose} />;
        }
        return <ListModalCreateView template={template} onClose={onClose} />;
    }

    if (listId === undefined) {
        return null;
    }

    return <ListModalLoadedView key={listId} mode={mode} listId={listId} onClose={onClose} />;
}
